/* eslint-disable no-unused-expressions */
/* global G */
import find from 'lib/sequence/component/children/find'
import { disable, enable } from 'lib/sequence/component/state/disabled'
import { hide } from 'lib/sequence/component/state/hidden'
import { get, reset, set } from 'lib/sequence/component/state/value'
import { asyncPipeSpread } from 'lib/util'
import displaySpentTime from '../partials/displaySpentTime'

const _getTeamKey = (module) => {
  const { content } = find(module[G.STATE][G.ACTION][G.COMPONENT])
  const { team: teamField } = find(content)

  return get(teamField)?.[0]?.key
}

/**
 * Presets the team.
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(*, ...[*]): Promise<*>}
 */
const presetTeam = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { team } = model[G.CHILDREN]
  const { content } = components

  const { team: teamField } = find(content)

  !get(teamField) && set(teamField, team[G.CACHE] || [])

  team[G.STATE][G.REF] = _getTeamKey(module)

  return [components, ...args]
}

/**
 * Presets the assignee.
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(*, ...[*]): Promise<*>}
 */
const presetAssignee = module => async (components, ...args) => {
  const { content } = components
  const { assignee: assigneeField } = find(content)

  const teamKey = _getTeamKey(module)
  const assigneeState = assigneeField[G.STATE]
  assigneeState[G.REF] = teamKey && 'team'

  teamKey
    ? enable(assigneeField)
    : reset(assigneeField) && disable(assigneeField)

  return [components, ...args]
}

/**
 * Displays the `delegationCloseAlert`.
 *
 * @param {Gaia.AppModule.Spec} module
 * @returns {function(*, ...[*]): Promise<*>}
 */
const displayDelegationCloseAlert = (module) => async (components, ...args) => {
  const { delegationCloseAlert, content } = components
  const { team: teamField } = find(content)

  hide(delegationCloseAlert, !get(teamField)?.[0]?.value.delegateAndCloseOnAssign)

  return [components, ...args]
}

/**
 * Ticket forward action.
 *
 * Toggles the visibility and mapping of fields depending on whether the service item should just be
 * saved for a ticket or as an individual entity in the database and whether there is already an
 * entity selected.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => () => async (...args) => asyncPipeSpread(
  presetTeam(module),
  presetAssignee(module),
  displaySpentTime(module),
  displayDelegationCloseAlert(module),
)(find(module[G.STATE][G.ACTION][G.COMPONENT]), ...args)

// export default module => component => async (...args) => {
//   const { delegationCloseAlert, content } = sequenceComponentFind(component)
//   const { assignee: assigneeField } = asObject(content[G.CHILDREN])
//   console.log('action', module[G.STATE][G.ACTION])

//   const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
//   const [forwardNoteType] = await listNoteTypes(module, actionComponent, { detail: { key: 'forward' } })
//   const t = isComplexTimeTrackingVisible(module, forwardNoteType)
//   console.log('t', t)

//   const assigneeState = assigneeField[G.STATE]
//   // checking whether a team is selected
//   // configuring assignee field
//   assigneeState[G.REF] = teamKey && 'team'
//   teamKey ? enable(assigneeField) : reset(assigneeField) && disable(assigneeField)
//   hide(delegationCloseAlert, !teamState.value?.[0]?.value.delegateAndCloseOnAssign)

//   return args
// }
